import FormSidebar from '../FormSidebar';

const CareerFormSidebar = () => (
    <FormSidebar>
        <div className="career-form">
            <p className="description-medium">
                Write to us, outlining your aspirations in a cover letter and attaching your educational documents, such
                as diplomas, references from former employers, and letters of recommendation.
            </p>
            <p className="description-medium">For all career-related questions, you can contact our manager:</p>
            <a href="/#" className="mail description-demibold">
                nadia@uniferx.com
            </a>
        </div>
    </FormSidebar>
);

export default CareerFormSidebar;
